import { render } from "./PantryOpticalAxisCompleteDialog.vue?vue&type=template&id=ca856972&scoped=true&ts=true"
import script from "./PantryOpticalAxisCompleteDialog.vue?vue&type=script&lang=ts"
export * from "./PantryOpticalAxisCompleteDialog.vue?vue&type=script&lang=ts"

import "./PantryOpticalAxisCompleteDialog.vue?vue&type=style&index=0&id=ca856972&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca856972"]])

export default __exports__